import React, { useState,useEffect } from 'react';
import SalesDetailModal from '../components/SalesDetailModal'; // モーダルコンポーネントをインポート
import { apiRequest } from "../utils/api"; // APIリクエスト用の関数
import '../styles/SalesDetailList.css';  // スタイルファイル

const SalesDetailList = ({ salesList, updateSalesDetail, removeSalesDetail, openModal, selectedItem, setSelectedItem, setShowModal, showModal, setBarcodeFocusEnabled }) => {
    const [conditions, setConditions] = useState([]);
    const [categorys, setCategorys] = useState([]);
   
    // 初回読み込み時実行
    useEffect(() => {
        fetchConditions();
        fetchCategory();
    }, []);

    const fetchConditions = async () => {
        try {
            const data = await apiRequest("inventory/conditions/", "GET");
            setConditions(data);
        } catch (error) {
            console.error("商品状態の取得に失敗しました:", error);
        }
    };
    
    const fetchCategory = async () => {
        try {
            const data = await apiRequest("inventory/categorys/", "GET");
            setCategorys(data);
        } catch (error) {
            console.error("カテゴリーの取得に失敗しました:", error);
        }
    };
    
    // 商品状態の表示（日本語での状態名）
    const getConditionText = (conditionId) => {
        const condition = conditions.find(cond => cond.id === conditionId);
        return condition ? condition.condition_jpn : '未選択';
    };


    // モーダルを閉じる
    const closeModal = () => {
        setShowModal(false);  // モーダルを閉じる
        setSelectedItem(null);  // 編集中の商品情報をリセット
        setBarcodeFocusEnabled(true);  // フォーカス戻す
    };
    const handleOutsideClick = (event) => {
        if (event.target === event.currentTarget) {
        closeModal();
        }
    };


    // モーダル内での入力変更処理
    const handleQuantityChange = (event) => {
        const updatedItem = { ...selectedItem, 
            quantity: parseInt(event.target.value) || 0,
            subtotal: (parseFloat(selectedItem.unit_price)-parseFloat(selectedItem.discount))*parseFloat(event.target.value) || 0 };
        setSelectedItem(updatedItem);
    };

    const handleUnitPriceChange = (event) => {
        const updatedItem = { ...selectedItem,
             unit_price: parseFloat(event.target.value) || 0 ,
             subtotal: parseFloat(selectedItem.quantity)*(parseFloat(event.target.value)-parseFloat(selectedItem.discount)) || 0 };
        setSelectedItem(updatedItem);
    };
    const handleDiscountChange = (event) => {
        const updatedItem = { ...selectedItem, 
            discount: parseInt(event.target.value) || 0,
            subtotal: parseFloat(selectedItem.quantity)*(parseFloat(selectedItem.unit_price)-parseInt(event.target.value)) || 0 };
        setSelectedItem(updatedItem);
    };    

    const handleConditionChange = (conditionId) => {
        const updatedItem = { ...selectedItem, condition: conditionId };
        setSelectedItem(updatedItem);
    };
    
    const handleCategoryChange = (categoryId) => {
        const updatedItem = { ...selectedItem, category: categoryId };
        setSelectedItem(updatedItem);
    };

    const handleBoxDamageChange = (checked) => {
        const updatedItem = { ...selectedItem, box_damage: checked };
        setSelectedItem(updatedItem);
    };

    const handleSpecialPriceChange = (checked) => {
        const updatedItem = { ...selectedItem, special_price: checked };
        setSelectedItem(updatedItem);
    };

    // 編集した内容を保存
    const saveChanges = () => {
        // 小計を更新
        const updatedItem = { ...selectedItem, subtotal: parseFloat(selectedItem.unit_price)*parseFloat(selectedItem.quantity) };
        setSelectedItem(updatedItem);

 
        const updatedSalesList = salesList.map((item) => 
            item.id === selectedItem.id ? selectedItem : item
        );
        updateSalesDetail(updatedSalesList);
        closeModal();  // モーダルを閉じる
    };

    const handleRemove = (index) => {
        const updatedSalesList = salesList.filter((_, i) => i !== index);
        removeSalesDetail(updatedSalesList);
    };
    
    // 同じ商品IDが複数あるかチェック
    const duplicateCounts = {};

    salesList.forEach((item) => {
        const id = item.inventory_fk_id;

        // 商品IDがない場合は対象外
        if (id === null || id === undefined || id === "" || String(id) === "0") {
            return;
        }

        const key = String(id);
        duplicateCounts[key] = (duplicateCounts[key] || 0) + 1;
    });

    // 重複している商品ID
    const duplicateIds = new Set(
        Object.keys(duplicateCounts).filter(
            (id) => duplicateCounts[id] >= 2
        )
    );
 
    return (
        <>
        <div className="salesDetailList">
            <table>
                <thead>
                    <tr>
                        <th>商品名</th>
                        <th>単価</th>
                        <th>商品状態</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {salesList.map((item, index) => (
                        <tr
                            key={`${item.id ?? item.inventory_fk_id ?? "item"}-${index}`}
                            className={
                                duplicateIds.has(String(item.inventory_fk_id))
                                    ? "salesDetailList_duplicate"
                                    : ""
                            }
                        >
                            <td
                                className="salesDetailList_name"
                                onClick={() => {
                                    openModal(item);
                                    setBarcodeFocusEnabled(false);
                                }}
                            >
                                <div className="salesDetailList_nameContent">

                                    {/* 商品画像 */}
                                    <div className="salesDetailList_thumbnail">
                                        <span>画像なし</span>

                                        {item.sku && (
                                            <img
                                                src={`/media/product_images/${encodeURIComponent(item.sku)}.jpg`}
                                                alt=""
                                                onError={(e) => {
                                                    e.currentTarget.style.display = "none";
                                                }}
                                            />
                                        )}
                                    </div>

                                    {/* 商品名 */}
                                    <span className="salesDetailList_productName">
                                        {item.set_ids &&
                                        item.set_ids.length > 0 &&
                                        item.set_ids[0] !== ""
                                            ? `【セット】 ${item.product_name}`
                                            : item.product_name}
                                    </span>

                                </div>
                            </td>
                            <td className='salesDetailList_price' onClick={() => {openModal(item); setBarcodeFocusEnabled(false);}}>{item.discount > 0 ? <>￥{item.unit_price}<br /><div className='salesDetailList_price_discount'>￥-{item.discount}</div></>: item.unit_price}</td>
                            <td className='salesDetailList_condition' onClick={() => {openModal(item); setBarcodeFocusEnabled(false);}}>{getConditionText(item.condition)}</td>
                            <td>
                                <button onClick={() => handleRemove(index)}>✖</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
            <div>
            <SalesDetailModal
                isOpen={showModal}
                onClose={closeModal}
                selectedItem={selectedItem}
                conditions={conditions}
                categorys={categorys}
                onSave={saveChanges}
                onChangeQuantity={handleQuantityChange}
                onChangeUnitPrice={handleUnitPriceChange}
                onChangeCondition={handleConditionChange}
                onChangeCategory={handleCategoryChange}
                onChangeBoxDamage={handleBoxDamageChange}
                onChangeSpecialPrice={handleSpecialPriceChange}
                handleOutsideClick={handleOutsideClick}
                onChangeDiscount ={handleDiscountChange}
                setBarcodeFocusEnabled={setBarcodeFocusEnabled}
            />
        </div>
        </>
    );
};

export default SalesDetailList;